import React from 'react'
import Title from '../../components/typography/title.component'
import Container from '../../components/layout/container.component'
import PartnerSelect from './components/partner-select.component'
import partnerConstants from './constants/partner.constants'
import PlanaltoContent from './partners/planalto/planalto.content'
import MoveflexStoreContent from './partners/moveflex-store/moveflex-store.content'
import LiveloContent from './partners/livelo/livelo.content'
import banner_pointsexchange from '../../../assets/images/troque-seus-pontos/troque-seus-pontos.png'
import banner_pointsexchange_mobile from '../../../assets/images/troque-seus-pontos/troque-seus-pontos-mobile.png'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { isMobile } from '../../helpers'
import { withRouter } from 'react-router-dom'
import { Creators as SiteCreators } from '../../ducks/site/site'

class PointsExchangePage extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedPartner: partnerConstants.MOVEFLEX_STORE,
		}

		this.renderPartner = renderPartner.bind(this)
		this.onSelectPartner = onSelectPartner.bind(this)
	}

	componentDidMount() {
		const { search } = this.props.location
		const selectedPartner = search && search.split('=').pop()

		const isValidPartner =
			Object.values(partnerConstants).includes(selectedPartner)

		if (isValidPartner) {
			this.setState({ selectedPartner })
		}
	}

	render() {
		return (
			<Container>
				{/* <Title>Troque seus pontos</Title>
				<img
					style={{ width: '100%' }}
					src={
						isMobile()
							? banner_pointsexchange_mobile
							: banner_pointsexchange
					}
					alt="Banner da compra de pontos"
				/> */}
				<PartnerSelect
					selected={this.state.selectedPartner}
					onSelect={this.onSelectPartner}
				/>
				{this.renderPartner()}
			</Container>
		)
	}
}

function renderPartner() {
	switch (this.state.selectedPartner) {
		case partnerConstants.MOVEFLEX_STORE:
			return <MoveflexStoreContent />
		// case partnerConstants.LIVELO:
		// 	return <LiveloContent />
		default:
			return <PlanaltoContent />
	}
}

function onSelectPartner(selectedPartner) {
	this.setState({ selectedPartner })
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
		},
		dispatch
	)

const connectedPointsExchangePage = withRouter(
	connect(null, mapDispatchToProps)(PointsExchangePage)
)

export { connectedPointsExchangePage as ModuleRootComponent }
